import { chakra } from '@chakra-ui/react'

export const GovtMastheadIcon = chakra(
  (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
    return (
      <svg
        width="1em"
        height="1em"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29 5.31s2.625 2.011-1.271 6.059c-3.897 4.048-.884 6.667-.884 6.667s-.701.666-.302 1.964c0 0-1.62-.9-2.86-2.429-1.792-2.209-2.887-5.59 2.033-8.285 0 0 3.247-1.607 2.594-3.75 0 0 .399.023.69-.227zm.75-.675c4.404 1.81 3.71 4.873 1.08 7.444-1.613 1.635-1.113 3.397-1.113 3.397S8.04 16.683 7.361 17.73c0 0-2.848-2.387 1.097-6.35 3.873-3.888 1.194-6.253 1.194-6.253l.047-.046c.087-.086.268-.28.34-.446zm4.13 8.873l-3.84 1.825s-.5-1.587 1.355-3.444c1.856-1.857 3.647-5.333-1.484-7.62 0 0 .097-.475-.242-.713 5.921-.175 8.035 6.81 4.211 9.952zm1.259-.762s1.133-1.59 1-3.73c-.08-2.873-2.34-5.953-7.196-5.778 4.743-3.952 12.972 4.873 6.196 9.508zM5.102 3.571c0 .584.993.512.993 0h2.928c.581 0 .992.286.605 1-.387.715-1.549.596-1.549.596.775 1.595-.46 3.142-2.105 3.142H4.23c-1.452 0-1.597.643-1.597.643-.92-1.262-.218-2.238-.218-2.238s.157.62 1.343.62 1.404-1.132.218-1.132h-.666c-.568 0-.92.298-.92.298s-.084-.202-.302-.786c-.218-.583.012-.81.17-.893.157-.083.496-.142.496-.142v-.274c-.279.024-.557.19-.557.19.024-1.024 1.259-1.024 1.259-1.024h1.645zM10.04 1c1.937 0 3.243.635 4.3 1.484 0 0-2.848-1.738-5.656.706H4.586s.524-.92 1.743-.92c.96 0 1.177-.484 1.177-.484l.01-.017C7.593 1.655 8.11 1 10.04 1z"
          fill="#DB0000"
        />
      </svg>
    )
  },
)
